module.exports = __webpack_public_path__ + "static/b36b58323241d89954eef84cf36ea18910d9dd1b50256138dd019adf2380aeb1-49b52ef7ce8370caa5374a2ea365f01d.jpeg";